/**
 * Created by uri.khaimov on 23/11/2017.
 */
import PropTypes from 'prop-types';

import React from 'react';
import Style from './badgesContainer.scss';
import StyledBadge from '../utils/Styled/badge';
import Cx from 'classnames';
import styled from 'styled-components';

const StyledGradientWrapper = styled.div`
   background: ${props => props.theme.linearGradientRight}
   .requestListItem:hover & {
        background: ${props => props.theme.linearGradientRightHover}
   }
   &.rtl{
      background: ${props => props.theme.linearGradientLeft}
    }
    .requestListItem:hover &.rtl {
        background: ${props => props.theme.linearGradientLeftHover}
   } 
`;

const BadgesContainer = function ({listItemId, listBadgesData}) {
    let badges = listBadgesData.map((badge)=> {
        if(badge) {
            return (
                <span key ={badge.key}  className={Style.reqInfo}>
				<StyledBadge className='badge'>
					{badge.keyCaption}: <span id={`${listItemId}_${badge.key}`}>{badge.valueCaption}</span>
				</StyledBadge>
			</span>
            )
        }

    });

    return (

        <div className={Style.badges}>
            {badges}
            <StyledGradientWrapper className={Cx(Style.gradient, document.dir)}/>
        </div>

    );

 };

BadgesContainer.propTypes = {
    listItemId: PropTypes.string.isRequired,
    listBadgesData: PropTypes.array.isRequired
};

export default BadgesContainer;



// WEBPACK FOOTER //
// ./components/Scoreboard/badgesContainer.js